<template>
  <resource-edit-wrapper
    :title="$t('resources.ab_tests.edit_ab_test')"
    :need-modal="showModal"
    @saveAction="$refs['abTestForm'].submit()">
    <AbTestForm :abTest="item" @isDirtyForm="isDirtyForm" is-edit ref="abTestForm" @finishedSaving="finishedSaving" />
    <template #actions>
      <v-btn-toggle
        v-if="$ability.can('update', 'ab_test')"
        class="va-btn-toggle outcome-btns"
        v-model="selectedOutcome"
        tile
        color="primary"
        group>
        <v-btn v-for="outcome in outcomeOptions" :key="outcome.value" :value="outcome.value">
          {{ outcome.text }}
        </v-btn>
      </v-btn-toggle>

      <v-btn
        v-if="item && $ability.can('update', 'ab_test')"
        @click="changeStatus"
        :loading="changeStatusLoading"
        outlined
        color="primary"
        class="cancel__btn">
        {{
          changeStatusValue !== AB_TEST_STATUSES.ACTIVE
            ? $t("resources.ab_tests.deactivate")
            : $t("resources.ab_tests.activate")
        }}
      </v-btn>

      <v-btn v-if="$ability.can('update', 'ab_test')" @click="save" :loading="saveLoading" color="primary">
        {{ $t("generic.buttons.save") }}
      </v-btn>
    </template>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import AbTestForm from "@/components/forms/AbTestForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";
  import { AB_TEST_STATUSES, AB_TEST_OUTCOMES } from "@/constant";
  import { formErrorMessage } from "@/utility/formErrorMessage";
  export default {
    components: {
      ResourceEditWrapper,
      AbTestForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        active: this.item?.active,
        saveLoading: false,
        changeStatusLoading: false,
        deleteLoading: false,
        AB_TEST_STATUSES,
        changeStatusValue: "",
        selectedOutcome: this.item?.outcome || undefined,
        outcomeOptions: [
          { value: AB_TEST_OUTCOMES.WIN, text: this.$t("resources.ab_tests.outcome_win") },
          { value: AB_TEST_OUTCOMES.LOSS, text: this.$t("resources.ab_tests.outcome_loss") },
          { value: AB_TEST_OUTCOMES.NEED_DATA, text: this.$t("resources.ab_tests.outcome_need_data") },
          { value: AB_TEST_OUTCOMES.INCONCLUSIVE, text: this.$t("resources.ab_tests.outcome_inconclusive") },
        ],
      };
    },
    mounted() {
      this.changeStatusValue = this.updateChangeStatusValue(this.item.status);
    },
    methods: {
      updateChangeStatusValue(currentStatus) {
        const statusTransitions = {
          [AB_TEST_STATUSES.DRAFT]: AB_TEST_STATUSES.ACTIVE,
          [AB_TEST_STATUSES.ACTIVE]: AB_TEST_STATUSES.INACTIVE,
          [AB_TEST_STATUSES.INACTIVE]: AB_TEST_STATUSES.ACTIVE,
        };

        return statusTransitions[currentStatus] || null;
      },
      save() {
        this.saveLoading = true;
        this.showModal = false;

        this.$refs["abTestForm"].form.outcome = this.selectedOutcome || null;
        this.$refs["abTestForm"].prepareBeforeSubmit(this.$refs["abTestForm"].form.status);
      },
      finishedSaving() {
        this.saveLoading = false;
        this.changeStatusLoading = false;
        this.deleteLoading = false;
      },
      async changeStatus() {
        try {
          this.changeStatusLoading = true;
          await this.$admin.dataProvider.customHttpCall("PATCH", `ab_tests/${this.item.id}`, {
            status: this.changeStatusValue,
          });
          if (this.changeStatusValue !== AB_TEST_STATUSES.ACTIVE) {
            this.$admin.toast.success(this.$t("resources.ab_tests.deactivate_success"));
          } else {
            this.$admin.toast.success(this.$t("resources.ab_tests.activate_success"));
            this.$refs["abTestForm"].callModalAfterSave();
          }

          this.changeStatusValue = this.updateChangeStatusValue(this.changeStatusValue);
          this.$refs["abTestForm"].form.status = this.updateChangeStatusValue(this.changeStatusValue);
        } catch (e) {
          this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
        } finally {
          this.changeStatusLoading = false;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "@core/preset/preset/functions.scss";

  .outcome-btns {
    border-radius: 4px;
    margin-right: 16px;

    .v-btn {
      margin: 0;
      box-shadow: none !important;
      border: 1px solid get-color("secondary-btn");
      border-right: 1px solid get-color("secondary-btn");
      min-width: unset;
      border-radius: 0;
      text-transform: none;
      font-weight: 500;

      &:first-child {
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0;
        border-right: 1px solid get-color("secondary-btn");
      }
    }

    .v-btn--active {
      background-color: #e1dbfc !important;
      border-color: var(--v-primary-base) !important;
      color: var(--v-primary-base) !important;
    }
  }
</style>
